import { Dialog, Popover, Transition } from "@headlessui/react"
import { Fragment, useState } from "react"
import { HiDotsVertical } from "react-icons/hi"
import RecycleFilled from "../../../../../components/svg/RecycleFilled"
import RecycleOutline from "../../../../../components/svg/RecycleOutline"
import { AiOutlineCloseCircle } from "react-icons/ai"

export default function Delete({
  answerOptionsId,
  answerOptions,
  setAnswerOptions
}) {
  const [isOpen, setIsOpen] = useState(false)
  const handleDelete = answerOptionsId => {
    const indexToRemove = answerOptions.findIndex(
      item => item.id === answerOptionsId
    )

    if (indexToRemove === -1) {
      return
    }

    const updatedAnswerOptions = [
      ...answerOptions.slice(0, indexToRemove),
      ...answerOptions.slice(indexToRemove + 1)
    ]

    const reorderedAnswerOptions = updatedAnswerOptions.map((item, index) => {
      if (index >= indexToRemove) {
        return {
          ...item,
          id: item.id - 1,
          title: String.fromCharCode(65 + index)
        }
      } else {
        return {
          ...item,
          title: String.fromCharCode(65 + index)
        }
      }
    })

    // Update the state with the reordered answer options
    setAnswerOptions(reorderedAnswerOptions)
  }
  return (
    <>
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button
              className={`focus:outline-none ${
                open
                  ? "-mx-1.5 -my-1.5 items-center justify-center rounded-full bg-primary px-1.5 py-1.5"
                  : ""
              }`}
            >
              <HiDotsVertical className="text-[14px] text-white sml:text-[20px]" />
            </Popover.Button>
            <Popover.Panel className="shadow-3 absolute top-[-18px] right-10 z-10 w-[232px] rounded-2xl bg-white py-5 px-5">
              <button
                className="flex items-center"
                onClick={() => setIsOpen(true)}
              >
                <RecycleFilled />
                <span className="pl-4 text-neutral-1">Delete</span>
              </button>
            </Popover.Panel>
          </>
        )}
      </Popover>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setIsOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className="w-[320px] transform overflow-hidden rounded-2xl bg-white 
                py-10 shadow-xl transition-all  sm:w-[485px] "
                >
                  <div
                    className="absolute top-0 right-0 cursor-pointer p-4 text-neutral-1"
                    onClick={() => setIsOpen(false)}
                  >
                    <AiOutlineCloseCircle size={28} />
                  </div>
                  <div className="curriculum-scroll no-scroll-track ml-auto mr-2 w-11/12 pr-4 sm:mr-4 sm:w-10/12 sm:pr-16">
                    <div className="flex justify-center">
                      <RecycleOutline />
                    </div>
                    <span className="flex pt-7 text-[20px] font-[500] text-neutral-1">
                      Are you sure you want to delete this subject ?
                    </span>

                    <div className="flex justify-center gap-8 pt-[43px]">
                      <button
                        className={`flex w-[121px] items-center justify-center self-center rounded-[8px] bg-neutral-5 py-3 px-5 font-[400] text-neutral-1`}
                        onClick={() => setIsOpen(false)}
                      >
                        <span className="body-2">Cancel</span>
                      </button>
                      <button
                        className={`flex w-[121px] items-center justify-center self-center rounded-[8px] bg-danger py-3 px-5 font-[400] text-white`}
                        onClick={() => {
                          setIsOpen(false)
                          handleDelete(answerOptionsId)
                        }}
                      >
                        <span className="body-2">Delete</span>
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
